<template>
	<div class="tw-flex-col tw--mx-3">
		<div class="px-3 tw-pb-3">
			<c-title-header
				:title="selectedJob.name"
				@go-to-back="goTo(codeStep.returnTo)"></c-title-header>
		</div>
		<div class="tw-flex">
			<div class="px-3 tw-w-3/5">
				<model-stepper
					:current-step="4"
					class="tw-mb-4"
					@code-step="loadCodeStep">
				</model-stepper>
				<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between tw-my-">
					<div class="tw-flex tw-justify-between tw-item-center">
						<p class="tw-text-app-color-primary text-lg">
							Escoger Carreras Requeridas
						</p>
						<p-button
							type="primary"
							@click="addInstruction">
							Agregar Instrucción
						</p-button>
					</div>
					<!-- <div class="tw-flex tw-justify-between tw-item-center tw-mb-6">
						<div class="tw-flex tw-flex-col tw-justify-center tw-gap-6">
							<label :style="`color:${$appColors.secondary}`">
								Experiencia
								<p-input-icon
									readonly
									:icon="'/static/img/edit-input.svg'"
									:data-view="experience"
									@click="openModalExperience"/>
							</label>
						</div>
					</div> -->
					<section class="tw-flex tw-flex-col tw-gap-6 instruction">
						<instruction-item
							class="tw-my-3"
							v-for="(instruction, index) in titlesSelected"
							:key="index"
							:item="instruction"
							:career-return="selectCareer"
							:index="index"
							@career-select="setCareers({ career: $event, index: index })"
							></instruction-item>
							<p-empty-message v-if="!titlesSelected.length">
								Escoger la instrucción requerida<br> para el puesto
							</p-empty-message>
					</section>
					<div>
						<p-horizontal-divider />
						<div class="tw-text-center">
							<p-button
								type="primary"
								@click="goTo(codeStep.returnTo)"
							>
								Atrás
							</p-button>
							<p-button
								type="secondary"
								:disabled="titlesSelected.length === 0 || validate"
								@click="savedStepFourth"
							>
								Siguiente
							</p-button>
						</div>
					</div>
				</p-card>
			</div>
			<div class="px-3 tw-w-2/5">
				<model-description
					:title="'INSTRUCCIÓN FORMAL'"
					:subtitle="'INSTRUCCIONES'">
					<div class="tw-my-4" slot="content">
						<p style="font-size: 13px;" class="tw-text-center">Decidan, del espectro de carreras existentes a nivel nacional 
							(por excepción internacional), la que más habilita para este puesto
						</p>
						<div class="content-box">
							<table>
								<tr>
									<td style="width: 25%; vertical-align: top;"><p>Ejemplo:</p></td>
									<td style="width: 75%">
										<span :style="`color:${$appColors.secondary}`">Bachiller</span><br>
										<span><b>Carreras Requeridas:</b></span><br>
										<span>Ingeniería Industrial</span><br>
										<span>Ingeniería en Sistemas</span><br>
										<span>Ingeniería Ambiental</span>
									</td>
								</tr>
							</table>
						</div>
						<div class="tw-flex tw-flex-col tw-items-center">
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
							>
								Mira nuestro tutorial paso a paso
							</p-button>
						</div>
					</div>
				</model-description>
			</div>
		</div>
		<!-- <p-modal
			ref="experienceModal"
			:max-width="650"
			:title="'Editar Experiencia Profesional'">
			<div slot="content">
				<div class=" tw-flex tw-justify-between tw-gap-x-3 tw-mx-6 tw-mt-5">
					<label :style="`color:${$appColors.info}`">
						Cantidad
						<input
							class="form-process-input"
							placeholder="Cantidad"
							v-model="experience.quantity"
						/>
					</label>
					<label :style="`color:${$appColors.info}`">
						Tiempo
						<v-select
							label="Tiempo"
							class="select-core"
							hide-details
							:menu-props="{ contentClass: 'type-select-content' }"
							height="37"
							outline
							single-line
							:items="dataDescription.times"
							item-value="id"
							item-text="name"
							return-object
							v-model="experience.time"
						></v-select>
					</label>
					<label :style="`color:${$appColors.info}`">
						Tipo
						<v-select
							label="Tipo"
							class="select-core"
							hide-details
							:menu-props="{ contentClass: 'type-select-content' }"
							height="37"
							outline
							single-line
							:items="dataDescription.measureOfTime"
							item-value="id"
							item-text="name"
							return-object
							v-model="experience.measureTime"
						></v-select>
					</label>
				</div>
				<p-horizontal-divider/>
				<div class="tw-text-center tw-mb-5">
					<p-button
						type="black"
						:disabled="!validateBtn"
						@click="$refs.experienceModal.close();">
						Cancelar
					</p-button>
					<p-button
						type="secondary"
						:disabled="!validateBtn"
						@click="$refs.experienceModal.close();">
						Guardar
					</p-button>
				</div>
			</div>
		</p-modal> -->
		<p-modal
			ref="addInstruction"
			:max-width="650"
			:title="'Editar Instrucción Formal'">
			<div slot="content">
				<div class="tw-flex tw-justify-between tw-mx-6 tw-mt-5">
					<v-select
						label="Seleccione los Títulos"
						class="select-core"
						hide-details
						multiple
						chips
						height="17"
						outline
						single-line
						autocomplete
						:items="titles.data"
						item-value="id"
						item-text="name"
						v-model="titlesData"
						return-object
						@input="getTitlesSelected($event)"
					>
						<template slot="selection" slot-scope="data">
							<v-chip
								class="tag-chip"
								close
								@click="removeItem(data.item)">
								{{ data.item.name }}
							</v-chip>
						</template>
					</v-select>
				</div>
				<p-horizontal-divider/>
				<div class="tw-text-center tw-mb-5">
					<p-button
						type="black"
						@click="$refs.addInstruction.close()">
						Cancelar
					</p-button>
					<p-button
						type="secondary"
						:disabled="titlesSelected.length === 0"
						@click="$refs.addInstruction.close()">
						Guardar
					</p-button>
				</div>
			</div>
		</p-modal>
	</div>
</template>

<script>
import cTitleHeader from '@/modules/job-profile/components/content/c-title-header';
import modelStepper from '@/modules/job-profile/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PInputIcon from '@/modules/shared/components/ui/p-input-icon';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import PModal from '@/modules/shared/components/ui/p-modal';
import InstructionItem from '@/modules/job-profile/components/fourth-step/instruction-item';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { path, pathOr } from 'ramda';

const { getLocalData } = helper;

async function loadData() {
	try {
		if (this.codeStep) {
			const { data: response } = await this.$httpPraktiko.get(`job-description/detail/${this.codeStep.code}/${this.selectedJob.id}`);
			if (Object.keys(response).length !== 0) {
				// this.experience = response.description.experience;
				this.titlesSelected = response.description.instructions;
				this.titlesData = response.description.instructions;
				this.selectCareer = response.description.instructions.map(f => f.career);
				this.validate = this.titlesSelected.some(c => c.career.length === 0);
			} else {
				this.titlesSelected = this.titles.data.filter(tl => tl.id === this.selectedJob.title);
				this.titlesSelected = this.titlesSelected.map((tS) => {
					const newTs = { ...tS };
					newTs.career = [];
					return newTs;
				});
				this.validate = this.titlesSelected.some(c => c.career.length === 0);
			}
		}
	} catch (error) {
		this.showGenericError();
	}
}

function loadCodeStep(obj) {
	this.codeStep = obj;
}

// function openModalExperience() {
// 	this.$refs.experienceModal.open();
// }

function addInstruction() {
	this.$refs.addInstruction.open();
}

function removeItem(item) {
	const index = this.titlesSelected.indexOf(item.id);
	if (index > -1) {
		this.titlesSelected.splice(index, 1);
	}
}

function getTitlesSelected(item) {
	item.forEach((obj) => {
		const exist = this.titlesSelected.some(f => f.id === obj.id);
		if (!exist) {
			const newObj = { ...obj };
			newObj.career = Array.isArray(obj.career) ? obj.career : [];
			this.titlesSelected.push(newObj);
		}
	});
	this.titlesSelected = this.titlesSelected
		.filter(a => item.some(i => i.id === a.id));
	this.validate = this.titlesSelected.some(c => c.career.length === 0);
}

// function validateBtn() {
// 	return this.experience && this.experience.quantity
// 		&& this.experience.time && this.experience.measureTime;
// }

function setCareers({ career, index }) {
	this.selectCareer[index] = career;
	this.titlesSelected[index].career = this.selectCareer[index];
	// 	if (!this.titlesSelected[index].career.find(f => f.id === obj.id)) {
	// 		this.titlesSelected[index].career.push(obj);
	// 	}
	// });
	// this.titlesSelected[index].career = this.titlesSelected[index].career
	// 	.filter(a => career.some(i => i.id === a.id));
	this.validate = this.titlesSelected.some(c => c.career.length === 0);
}

async function savedStepFourth() {
	this.titlesSelected = this.titlesSelected.map((f) => {
		const newF = {
			id: f.id,
			name: f.name,
			code: f.code,
			career: f.career,
		};
		return newF;
	});
	// const newObject = {
	// 	quantity: parseInt(this.experience.quantity, 10),
	// 	time: {
	// 		id: this.experience.time.id,
	// 		name: this.experience.time.name,
	// 		code: this.experience.time.code,
	// 	},
	// 	measureTime: {
	// 		id: this.experience.measureTime.id,
	// 		name: this.experience.measureTime.name,
	// 		code: this.experience.measureTime.code,
	// 	},
	// };
	const body = {
		description: {
			// experience: newObject,
			instructions: this.titlesSelected,
		},
		typeDescriptionCode: this.codeStep.code,
		jobId: this.selectedJob.id,
	};
	try {
		await this.$httpPraktiko.post('job-description', body);
		this.showNotification('Instrucción Formal Guardada Exitosamente');
		this.goTo(this.codeStep.goTo);
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		codeStep: {},
		titlesSelected: [],
		titlesData: [],
		selectCareer: [],
		experience: {
			quantity: null,
			time: '',
			measureTime: '',
		},
		validate: false,
	};
}


export default {
	name: 'job-formal-instructions',
	beforeCreate() {
		this.$store.dispatch('jobEvaluation/loadTitles');
		this.$store.dispatch('jobProfile/loadKnowledges');
		this.$store.dispatch('jobProfile/loadCareers');
		this.$store.dispatch('jobProfile/loadTimes');
		this.$store.dispatch('jobProfile/loadMeasureOfTime');
	},
	created() {
	},
	mounted() {
	},
	data,
	components: {
		cTitleHeader,
		modelStepper,
		PCard,
		PEmptyMessage,
		PButton,
		PInputIcon,
		PHorizontalDivider,
		modelDescription,
		PModal,
		InstructionItem,
	},
	methods: {
		loadData,
		loadCodeStep,
		// openModalExperience,
		addInstruction,
		removeItem,
		getTitlesSelected,
		setCareers,
		savedStepFourth,
	},
	computed: {
		...mapState('jobProfile', {
			dataDescription: path(['descriptionData']),
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
			// pathOr([], ['selectedJob']) || getLocalData('selectedJob'),
		}),
		...mapState('jobEvaluation', {
			titles: path(['supplies', 'guidelineModel', 'levelSelection', 'title']),
		}),
		// validateBtn,
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},
		titles: {
			handler(newVal) {
				this.titlesSelected = newVal.data.filter(tl => tl.id === this.selectedJob.title);
				this.titlesSelected = this.titlesSelected.map((tS) => {
					const newTs = { ...tS };
					newTs.career = [];
					return newTs;
				});
				this.validate = this.titlesSelected.some(c => c.career.length === 0);
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.content-box {
	border: 1px solid color(border-gray);
	background-color: color(gray-light);
	border-radius: 5px;
	height: auto;
	width: 100%;
	padding: 10px;
	table {
		width: 100%;
		// border-collapse: collapse;
		text-align: left;
		font-size: 12px;
	}
}
.instruction {
	overflow: auto;
	height: 40vh;
	// margin-top: 20px;
}
.form-process {
	bottom: 0;
	left: 0;
	padding: 0;
	position: relative !important;
	right: 0;

	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
        display: block;
        outline: none;
		color: map-get($colors, secondary);
		// margin-top: 4px;
		padding: 10px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/fourth page/job-formal-instructions.vue